var map = {
	"./prize-1.png": 90,
	"./prize-1@2x.png": 91,
	"./prize-2.png": 92,
	"./prize-2@2x.png": 93,
	"./prize-3.png": 94,
	"./prize-3@2x.png": 95,
	"./prize-4.png": 96,
	"./prize-4@2x.png": 97,
	"./prize-5.png": 98,
	"./prize-5@2x.png": 99,
	"./prize-6.png": 100,
	"./prize-6@2x.png": 101,
	"./prize-7.png": 102,
	"./prize-7@2x.png": 103,
	"./prize-8.png": 104,
	"./prize-8@2x.png": 105,
	"./prize-9.png": 106,
	"./prize-9@2x.png": 107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 257;



//////////////////
// WEBPACK FOOTER
// ./themes/hm/img ^\.\/prize\-.*\.png$
// module id = 257
// module chunks = 3